// extracted by css-extract-rspack-plugin
export default {"appleImageBox":"StoreButton-module__appleImageBox__DLr73","googleImageBox":"StoreButton-module__googleImageBox__ZxElh"};